import React, { type FunctionComponent } from 'react'
import { TextButton } from 'gin-and-tonic/common/text-button/TextButton'
import { useDomainGoToPath } from 'domains/insights-portal/utils/domain/routing'
import { useDomainMessage } from 'domains/insights-portal/utils/domain/intl'
import { InsightsPortalProvider } from 'domains/insights-portal/utils/provider/InsightsPortalProvider'
import { useRetailerId } from 'utils/routing/params.hooks'
import { SummaryPerformance } from 'domains/insights-portal/components/summary/components/metrics/SummaryPerformance'

interface InsightsPortalSummaryProps {
  hasInsightsAccess?: boolean
}

export const InsightsPortalSummary: FunctionComponent<InsightsPortalSummaryProps> = ({
  hasInsightsAccess,
}) => {
  const goToExecutiveSummary = useDomainGoToPath('insights-portal-executive-summary')

  const viewAllLabel = useDomainMessage('insightsPortalDomain.viewAll')

  const retailerId = useRetailerId()

  const filtersObjOverride = {
    retailer: [{ label: '', value: retailerId }],
  }

  return (
    <InsightsPortalProvider>
      {hasInsightsAccess && (
        <div css={{ display: 'flex', justifyContent: 'flex-end' }}>
          <TextButton onClick={goToExecutiveSummary}>{viewAllLabel}</TextButton>
        </div>
      )}

      <SummaryPerformance filtersObjOverride={filtersObjOverride} />
    </InsightsPortalProvider>
  )
}
